import naturalCompare from 'natural-compare-lite';




import { WsDeliverConfigSchemaItem, WsDeliverConfigSchemaMapping } from '../../../../../core/src/interfaces';

import { WsDeliverConfigItemType, WsDeliverConfigSchemaMappingStatus, WsDeliverConfigWorkload } from '../../../enums';




type WsMappedItem = [
  WsDeliverConfigSchemaMappingStatus,
  string,
  string?
];




const getStaticResourceMappingList = (sorted: boolean) => {

  const list: WsMappedItem[] = [

    // entra

    [ WsDeliverConfigSchemaMappingStatus.ReadOnly, '/PowerShell/AzureADDeviceConfiguration/',                            '' ],
    [ WsDeliverConfigSchemaMappingStatus.Mapped,   '/PowerShell/AzureADMSAuthorizationPolicy/',                          '/DSC/AADAuthorizationPolicy/' ],
    [ WsDeliverConfigSchemaMappingStatus.Mapped,   '/PowerShell/AzureADMSGroup/',                                        '/DSC/AADGroup/' ],
    [ WsDeliverConfigSchemaMappingStatus.Mapped,   '/PowerShell/AzureADMSGroup/AzureADMSGroup/',                         '/DSC/AADGroup/AADGroup/' ],
    [ WsDeliverConfigSchemaMappingStatus.Mapped,   '/PowerShell/EntraAdministrativeUnit/',                               '/DSC/AADAdministrativeUnit/' ],
    [ WsDeliverConfigSchemaMappingStatus.Mapped,   '/PowerShell/EntraAdministrativeUnit/EntraAdministrativeUnit/',       '/DSC/AADAdministrativeUnit/AADAdministrativeUnit/' ],
    [ WsDeliverConfigSchemaMappingStatus.Mapped,   '/PowerShell/EntraApplication/',                                      '/DSC/AADApplication/' ],
    [ WsDeliverConfigSchemaMappingStatus.Mapped,   '/PowerShell/EntraApplication/EntraApplication/',                     '/DSC/AADApplication/AADApplication/' ],

    [ WsDeliverConfigSchemaMappingStatus.Missing,  '/PowerShell/EntraApplicationKeyCredential/',                         '' ],
    [ WsDeliverConfigSchemaMappingStatus.Missing,  '/PowerShell/EntraApplicationPasswordCredential/',                    '' ],

    [ WsDeliverConfigSchemaMappingStatus.Mapped,   '/PowerShell/EntraAuthorizationPolicy/',                              '/DSC/AADAuthorizationPolicy/' ],
    [ WsDeliverConfigSchemaMappingStatus.Mapped,   '/PowerShell/EntraDeletedApplication/',                               '/DSC/AADApplication/AADApplication/' ],
    [ WsDeliverConfigSchemaMappingStatus.Mapped,   '/PowerShell/EntraDeletedApplication/EntraDeletedApplication/',       '/DSC/AADApplication/AADApplication/' ],

    [ WsDeliverConfigSchemaMappingStatus.Ignore,   '/PowerShell/EntraContext/',                                          '' ],

    [ WsDeliverConfigSchemaMappingStatus.Missing,   '/PowerShell/EntraDevice/',                                           '' ],

    [ WsDeliverConfigSchemaMappingStatus.Mapped,   '/PowerShell/EntraDirectoryRole/',                                    '/DSC/AADRoleDefinition/' ],
    [ WsDeliverConfigSchemaMappingStatus.Mapped,   '/PowerShell/EntraDirectoryRole/EntraDirectoryRole/',                 '/DSC/AADRoleDefinition/AADRoleDefinition/' ],
    [ WsDeliverConfigSchemaMappingStatus.Mapped,   '/PowerShell/EntraDirectoryRole/EntraDirectoryRole/RoleTemplateId/',  '/DSC/AADRoleDefinition/AADRoleDefinition/TemplateId/' ],

    [ WsDeliverConfigSchemaMappingStatus.ReadOnly, '/PowerShell/EntraDirectoryRoleMember/',                              '' ],

    [ WsDeliverConfigSchemaMappingStatus.Mapped,   '/PowerShell/EntraDirectoryRoleTemplate/',                            '/DSC/AADRoleDefinition/' ],
    [ WsDeliverConfigSchemaMappingStatus.Mapped,   '/PowerShell/EntraDirectoryRoleTemplate/EntraDirectoryRoleTemplate/', '/DSC/AADRoleDefinition/AADRoleDefinition/' ],

    [ WsDeliverConfigSchemaMappingStatus.Ignore,   '/PowerShell/EntraDomain/',                                           '' ],

    [ WsDeliverConfigSchemaMappingStatus.ReadOnly, '/PowerShell/EntraDomainNameReference/',                              '' ],

    [ WsDeliverConfigSchemaMappingStatus.ReadOnly,  '/PowerShell/EntraDomainServiceConfigurationRecord/',                 '' ],

    [ WsDeliverConfigSchemaMappingStatus.ReadOnly,  '/PowerShell/EntraDomainVerificationDnsRecord/',                      '' ],

    [ WsDeliverConfigSchemaMappingStatus.Ignore,   '/PowerShell/EntraEnvironment/',                                      '' ],

    [ WsDeliverConfigSchemaMappingStatus.Mapped,   '/PowerShell/EntraGroup/',                                            '/DSC/AADGroup/' ],
    [ WsDeliverConfigSchemaMappingStatus.Mapped,   '/PowerShell/EntraGroup/EntraGroup/',                                 '/DSC/AADGroup/AADGroup/' ],

    [ WsDeliverConfigSchemaMappingStatus.Ignore,   '/PowerShell/EntraGroupMember/',                                      '' ],
    [ WsDeliverConfigSchemaMappingStatus.Ignore,   '/PowerShell/EntraGroupOwner/',                                       '' ],

    [ WsDeliverConfigSchemaMappingStatus.ReadOnly,  '/PowerShell/EntraIdentityProvider/',                                '' ],
    [ WsDeliverConfigSchemaMappingStatus.ReadOnly,  '/PowerShell/EntraOAuth2PermissionGrant/',                                '' ],
    [ WsDeliverConfigSchemaMappingStatus.Ignore,    '/PowerShell/EntraObjectByObjectId/',                                '' ],

    [ WsDeliverConfigSchemaMappingStatus.Missing,   '/PowerShell/EntraPartnerInformation/',                                '' ],

    [ WsDeliverConfigSchemaMappingStatus.Ignore,   '/PowerShell/EntraPasswordPolicy/',                                '' ],
    [ WsDeliverConfigSchemaMappingStatus.Ignore,   '/PowerShell/EntraPermissionGrantPolicy/',                                '' ],
    [ WsDeliverConfigSchemaMappingStatus.Ignore,   '/PowerShell/EntraRoleAssignment/',                                '' ],

    [ WsDeliverConfigSchemaMappingStatus.Mapped,   '/PowerShell/EntraRoleDefinition/',                                   '/DSC/AADRoleDefinition/' ],
    [ WsDeliverConfigSchemaMappingStatus.Mapped,   '/PowerShell/EntraRoleDefinition/EntraRoleDefinition/',               '/DSC/AADRoleDefinition/AADRoleDefinition/' ],
    [ WsDeliverConfigSchemaMappingStatus.Ignore,   '/PowerShell/EntraScopedRoleMembership/',                             '' ],
    [ WsDeliverConfigSchemaMappingStatus.Mapped,   '/PowerShell/EntraServicePrincipal/',                                 '/DSC/AADServicePrincipal/' ],
    [ WsDeliverConfigSchemaMappingStatus.Mapped,   '/PowerShell/EntraServicePrincipal/EntraServicePrincipal/',           '/DSC/AADServicePrincipal/AADServicePrincipal/' ],

    [ WsDeliverConfigSchemaMappingStatus.ReadOnly, '/PowerShell/EntraSubscribedSku/',                                    '' ],

    [ WsDeliverConfigSchemaMappingStatus.ReadOnly, '/PowerShell/EntraTenantDetail/',                                     '' ],

    [ WsDeliverConfigSchemaMappingStatus.Mapped,   '/PowerShell/EntraUserAppRoleAssignment/',                            '/DSC/AADServicePrincipal/AADServicePrincipal/AppRoleAssignedTo/' ],
    [ WsDeliverConfigSchemaMappingStatus.Mapped,   '/PowerShell/EntraUserAppRoleAssignment/EntraUserAppRoleAssignment/', '/DSC/AADServicePrincipal/AADServicePrincipal/AppRoleAssignedTo/MSFT_AADServicePrincipalRoleAssignment/' ],

    [ WsDeliverConfigSchemaMappingStatus.ReadOnly, '/PowerShell/EntraUserLicenseDetail/',                                '' ],

    [ WsDeliverConfigSchemaMappingStatus.Ignore,  '/PowerShell/EntraUserOwnedDevice/',                                   '/DSC/AADGroup/' ],
    [ WsDeliverConfigSchemaMappingStatus.Ignore,  '/PowerShell/EntraUserMembership/',                                    '/DSC/AADGroup/' ],
    [ WsDeliverConfigSchemaMappingStatus.Ignore,  '/PowerShell/EntraUserOwnedObject/',                                   '/DSC/AADGroup/' ],
    [ WsDeliverConfigSchemaMappingStatus.Ignore,  '/PowerShell/EntraUserRegisteredDevice/',                              '/DSC/AADGroup/' ],

    [ WsDeliverConfigSchemaMappingStatus.Missing,  '/PowerShell/MgBetaEntitlementManagementAccessPackageCatalog/',       '' ],







    // exchange

    [ WsDeliverConfigSchemaMappingStatus.Mapped,   '/PowerShell/AcceptedDomain/',                '/DSC/EXOAcceptedDomain/' ],
    [ WsDeliverConfigSchemaMappingStatus.Mapped,   '/PowerShell/AcceptedDomain/AcceptedDomain/', '/DSC/EXOAcceptedDomain/EXOAcceptedDomain/' ],

    [ WsDeliverConfigSchemaMappingStatus.Missing,  '/PowerShell/ActiveSyncMailboxPolicy/',        '' ],
    [ WsDeliverConfigSchemaMappingStatus.Missing,  '/PowerShell/ActiveSyncOrganizationSettings/', '' ],

    [ WsDeliverConfigSchemaMappingStatus.Missing,  '/PowerShell/AdminAuditLogConfig/', '' ],

    [ WsDeliverConfigSchemaMappingStatus.Missing,  '/PowerShell/AdministrativeUnit/', '' ],

    [ WsDeliverConfigSchemaMappingStatus.Mapped,   '/PowerShell/AntiPhishPolicy/',               '/DSC/EXOAntiPhishPolicy/EXOAntiPhishPolicy/' ],

    [ WsDeliverConfigSchemaMappingStatus.Missing,   '/PowerShell/App/',                            '' ],

    [ WsDeliverConfigSchemaMappingStatus.ReadOnly, '/PowerShell/ATPBuiltInProtectionRule/', '' ],

    [ WsDeliverConfigSchemaMappingStatus.Mapped,   '/PowerShell/AtpPolicyForO365/',               '/DSC/EXOAtpPolicyForO365/' ],

    [ WsDeliverConfigSchemaMappingStatus.ReadOnly, '/PowerShell/AuthServer/',                    '' ],

    [ WsDeliverConfigSchemaMappingStatus.Mapped,   '/PowerShell/CalendarProcessing/',             '/DSC/EXOCalendarProcessing/EXOCalendarProcessing/' ],

    [ WsDeliverConfigSchemaMappingStatus.Missing,  '/PowerShell/ClassificationRuleCollection/',   '' ],

    [ WsDeliverConfigSchemaMappingStatus.Missing,  '/PowerShell/Clutter/',                       '' ],

    [ WsDeliverConfigSchemaMappingStatus.ReadOnly,  '/PowerShell/ConfigAnalyzerPolicyRecommendation/',   '' ],

    [ WsDeliverConfigSchemaMappingStatus.ReadOnly, '/PowerShell/ConnectionInformation/',                    '' ],

    [ WsDeliverConfigSchemaMappingStatus.Mapped,   '/PowerShell/DataClassificationConfig/',       '/DSC/EXODataClassification/EXODataClassification/' ],

    [ WsDeliverConfigSchemaMappingStatus.ReadOnly, '/PowerShell/DefaultTenantMyAnalyticsFeatureConfig/',     '' ],
    [ WsDeliverConfigSchemaMappingStatus.ReadOnly, '/PowerShell/DnssecStatusForVerifiedDomain/',             '' ],
    [ WsDeliverConfigSchemaMappingStatus.ReadOnly, '/PowerShell/EmailTenantSettings/',                       '' ],
    [ WsDeliverConfigSchemaMappingStatus.ReadOnly, '/PowerShell/EtrLimits/',                                 '' ],



    // [ WsDeliverConfigSchemaMappingStatus.Review,   '/PowerShell/EXOCasMailbox/',   '' ],

    // [ WsDeliverConfigSchemaMappingStatus.Review,   '/PowerShell/EXOMailbox/',   '' ],

    // [ WsDeliverConfigSchemaMappingStatus.Review,   '/PowerShell/EXOMailboxPermission/',   '' ],

    // [ WsDeliverConfigSchemaMappingStatus.Review,   '/PowerShell/EXOMailboxStatistics/',   '' ],

    // [ WsDeliverConfigSchemaMappingStatus.Review,   '/PowerShell/EXORecipient/',   '' ],

    // [ WsDeliverConfigSchemaMappingStatus.Review,   '/PowerShell/ExternalInOutlook/',   '' ],

    [ WsDeliverConfigSchemaMappingStatus.ReadOnly, '/PowerShell/FederatedOrganizationIdentifier/',                                 '' ],

    [ WsDeliverConfigSchemaMappingStatus.ReadOnly, '/PowerShell/FederationInformation/',                                 '' ],

    [ WsDeliverConfigSchemaMappingStatus.ReadOnly, '/PowerShell/FederationTrust/',                                 '' ],

    

    

    


    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/Group/',                          '/DSC/EXOGroupSettings/' ],

    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/Group/Group/',                    '/DSC/EXOGroupSettings/EXOGroupSettings/' ],

    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/HostedConnectionFilterPolicy/',   '/DSC/EXOHostedConnectionFilterPolicy/EXOHostedConnectionFilterPolicy/' ],

    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/HostedContentFilterPolicy/',      '/DSC/EXOHostedContentFilterPolicy/EXOHostedContentFilterPolicy/' ],

    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/HostedOutboundSpamFilterPolicy/', '/DSC/EXOHostedOutboundSpamFilterPolicy/EXOHostedOutboundSpamFilterPolicy/' ],

    [ WsDeliverConfigSchemaMappingStatus.ReadOnly,  '/PowerShell/HybridMailflowDatacenterIPs/',             '' ],

    [ WsDeliverConfigSchemaMappingStatus.ReadOnly,  '/PowerShell/IntraOrganizationConfiguration/',             '' ],

    [ WsDeliverConfigSchemaMappingStatus.Missing,  '/PowerShell/IRMConfiguration/',             '' ],

    [ WsDeliverConfigSchemaMappingStatus.Missing,  '/PowerShell/Mailbox/',             '' ],  

    // [ WsDeliverConfigSchemaMappingStatus.Review,  '/PowerShell/MailboxAuditBypassAssociation/',             '' ],

    // [ WsDeliverConfigSchemaMappingStatus.Review,  '/PowerShell/MailboxAutoReplyConfiguration/',             '' ],

    // [ WsDeliverConfigSchemaMappingStatus.Review,  '/PowerShell/MailboxCalendarConfiguration/',             '' ],

    // [ WsDeliverConfigSchemaMappingStatus.Review,  '/PowerShell/MailboxJunkEmailConfiguration/',             '' ],

    // [ WsDeliverConfigSchemaMappingStatus.Review,  '/PowerShell/MailboxLocation/',             '' ],    

    // [ WsDeliverConfigSchemaMappingStatus.Review,  '/PowerShell/MailboxMessageConfiguration/',             '' ],

    // [ WsDeliverConfigSchemaMappingStatus.Review,  '/PowerShell/MailboxPermission/',             '' ],

    // [ WsDeliverConfigSchemaMappingStatus.Review,  '/PowerShell/MailboxPlan/',             '' ],

    // [ WsDeliverConfigSchemaMappingStatus.Review,  '/PowerShell/MailboxRegionalConfiguration/',             '' ],

    // [ WsDeliverConfigSchemaMappingStatus.Review,  '/PowerShell/MailboxSpellingConfiguration/',             '' ],

    // [ WsDeliverConfigSchemaMappingStatus.Review,  '/PowerShell/MailDetailATPReport/',             '' ],

    // [ WsDeliverConfigSchemaMappingStatus.Review,  '/PowerShell/MailFilterListReport/',             '' ],

    // [ WsDeliverConfigSchemaMappingStatus.Review,  '/PowerShell/MailflowStatusReport/',             '' ],

    // [ WsDeliverConfigSchemaMappingStatus.Review,  '/PowerShell/MailTrafficATPReport/',             '' ],

    // [ WsDeliverConfigSchemaMappingStatus.Review,  '/PowerShell/MailUser/',             '' ],    

    // [ WsDeliverConfigSchemaMappingStatus.Review,  '/PowerShell/MalwareFilterPolicy/',             '' ],

    // [ WsDeliverConfigSchemaMappingStatus.Review,  '/PowerShell/ManagementRole/',             '' ],

    // [ WsDeliverConfigSchemaMappingStatus.Review,  '/PowerShell/ManagementRoleAssignment/',             '' ],

    // [ WsDeliverConfigSchemaMappingStatus.Review,  '/PowerShell/ManagementRoleEntry/',             '' ],

    // [ WsDeliverConfigSchemaMappingStatus.Review,  '/PowerShell/MessageTrace/',             '' ],

    // [ WsDeliverConfigSchemaMappingStatus.Review,  '/PowerShell/MigrationConfig/',             '' ],

    // [ WsDeliverConfigSchemaMappingStatus.Review,  '/PowerShell/MigrationStatistics/',             '' ],    

    // [ WsDeliverConfigSchemaMappingStatus.Review,  '/PowerShell/MobileDeviceMailboxPolicy/',             '' ],

    // [ WsDeliverConfigSchemaMappingStatus.Review,  '/PowerShell/MxRecordReport/',             '' ],

    // [ WsDeliverConfigSchemaMappingStatus.Review,  '/PowerShell/OMEConfiguration/',             '' ],

    // [ WsDeliverConfigSchemaMappingStatus.Review,  '/PowerShell/OrganizationalUnit/',             '' ],

    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/OrganizationConfig/',             '/DSC/EXOOrganizationConfig/' ],

    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/OwaMailboxPolicy/',               '/DSC/EXOOwaMailboxPolicy/EXOOwaMailboxPolicy/' ],

    [ WsDeliverConfigSchemaMappingStatus.Missing,  '/PowerShell/PerimeterConfig/' ],

    [ WsDeliverConfigSchemaMappingStatus.Missing,  '/PowerShell/PolicyConfig/'    ],

    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/QuarantinePolicy/',               '/DSC/EXOQuarantinePolicy/' ],
    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/QuarantinePolicy/',               '/DSC/EXOQuarantinePolicy/EXOQuarantinePolicy/' ],

    [ WsDeliverConfigSchemaMappingStatus.ReadOnly, '/PowerShell/Recipient/' ],

    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/RemoteDomain/',                   '/DSC/EXORemoteDomain/EXORemoteDomain/' ],

    [ WsDeliverConfigSchemaMappingStatus.Missing, '/PowerShell/RetentionPolicy/',                '' ],

    [ WsDeliverConfigSchemaMappingStatus.Missing, '/PowerShell/RetentionPolicyTag/',             '' ],

    [ WsDeliverConfigSchemaMappingStatus.Missing, '/PowerShell/RMSTemplate/',             '' ],    

    [ WsDeliverConfigSchemaMappingStatus.Mapped, '/PowerShell/RoleGroup/',           '/DSC/EXORoleGroup/' ],
    [ WsDeliverConfigSchemaMappingStatus.Mapped, '/PowerShell/RoleGroup/RoleGroup/', '/DSC/EXORoleGroup/EXORoleGroup/' ],

    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/RoleAssignmentPolicy/',            '/DSC/EXORoleAssignmentPolicy/EXORoleAssignmentPolicy/' ],

    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/SafeAttachmentPolicy/',            '/DSC/EXOSafeAttachmentPolicy/EXOSafeAttachmentPolicy/' ],

    [ WsDeliverConfigSchemaMappingStatus.ReadOnly, '/PowerShell/SafeLinksAggregateReport/' ],

    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/SafeLinksPolicy/',                 '/DSC/EXOSafeLinksPolicy/EXOSafeLinksPolicy/' ],

    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/SharingPolicy/',                   '/DSC/EXOSharingPolicy/EXOSharingPolicy/' ],

    [ WsDeliverConfigSchemaMappingStatus.Missing, '/PowerShell/SmimeConfig/' ],

    [ WsDeliverConfigSchemaMappingStatus.Ignore,   '/PowerShell/SmtpDaneInboundStatus/',           '' ],

    [ WsDeliverConfigSchemaMappingStatus.Missing,  '/PowerShell/SupervisoryReviewPolicyV2/' ],

    [ WsDeliverConfigSchemaMappingStatus.Missing,  '/PowerShell/SupervisoryReviewRule/' ],

    [ WsDeliverConfigSchemaMappingStatus.Missing,  '/PowerShell/TeamsProtectionPolicy/' ],

    [ WsDeliverConfigSchemaMappingStatus.Mapped,   '/PowerShell/TransportConfig/',                 '/DSC/EXOTransportConfig/' ],

    [ WsDeliverConfigSchemaMappingStatus.ReadOnly, '/PowerShell/TransportRuleAction/' ],

    [ WsDeliverConfigSchemaMappingStatus.ReadOnly, '/PowerShell/TransportRulePredicate/' ],

    [ WsDeliverConfigSchemaMappingStatus.Missing,  '/PowerShell/UnifiedGroup/',                 '' ],

    [ WsDeliverConfigSchemaMappingStatus.Missing,  '/PowerShell/User/',                 '' ],

    [ WsDeliverConfigSchemaMappingStatus.ReadOnly, '/PowerShell/VivaFeatureCategory/',                 '' ],

    [ WsDeliverConfigSchemaMappingStatus.ReadOnly, '/PowerShell/VivaInsightsSettings/',                 '' ],

    [ WsDeliverConfigSchemaMappingStatus.ReadOnly, '/PowerShell/VivaModuleFeature/',                 '' ],










    // intune

    [ WsDeliverConfigSchemaMappingStatus.Missing, '/PowerShell/MgBetaDeviceAppManagementMobileApp/' ],

    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/MgBetaDeviceManagementAssignmentFilter/',                                        '/DSC/IntuneDeviceAndAppManagementAssignmentFilter/' ],
    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/MgBetaDeviceManagementAssignmentFilter/MgBetaDeviceManagementAssignmentFilter/', '/DSC/IntuneDeviceAndAppManagementAssignmentFilter/IntuneDeviceAndAppManagementAssignmentFilter/' ],

    [ WsDeliverConfigSchemaMappingStatus.Mapped, '/PowerShell/MgBetaDeviceManagementConfigurationPolicy/',                                           '/DSC/IntuneSettingCatalogASRRulesPolicyWindows10/' ],
    [ WsDeliverConfigSchemaMappingStatus.Mapped, '/PowerShell/MgBetaDeviceManagementConfigurationPolicy/MgBetaDeviceManagementConfigurationPolicy/', '/DSC/IntuneSettingCatalogASRRulesPolicyWindows10/IntuneSettingCatalogASRRulesPolicyWindows10/' ],

    [ WsDeliverConfigSchemaMappingStatus.Mapped, '/PowerShell/MgBetaDeviceManagementDeviceCategory/',                                           '/DSC/IntuneDeviceCategory/IntuneDeviceCategory/' ],

    [ WsDeliverConfigSchemaMappingStatus.Mapped, '/PowerShell/MgBetaDeviceManagementDeviceCompliancePolicy/',                                              '/DSC/IntuneDeviceCompliancePolicyWindows10/' ],
    [ WsDeliverConfigSchemaMappingStatus.Mapped, '/PowerShell/MgBetaDeviceManagementDeviceCompliancePolicy/MgBetaDeviceManagementDeviceCompliancePolicy/', '/DSC/IntuneDeviceCompliancePolicyWindows10/IntuneDeviceCompliancePolicyWindows10/' ],

    [ WsDeliverConfigSchemaMappingStatus.Mapped, '/PowerShell/MgBetaDeviceManagementDeviceConfiguration/',                                           '/DSC/IntuneDeviceConfigurationCustomPolicyWindows10/' ],
    [ WsDeliverConfigSchemaMappingStatus.Mapped, '/PowerShell/MgBetaDeviceManagementDeviceConfiguration/MgBetaDeviceManagementDeviceConfiguration/', '/DSC/IntuneDeviceConfigurationCustomPolicyWindows10/IntuneDeviceConfigurationCustomPolicyWindows10/' ],

    [ WsDeliverConfigSchemaMappingStatus.Missing, '/PowerShell/MgBetaDeviceManagementIntent/' ],

    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/MgBetaDeviceManagementRoleAssignment/',                                          '/DSC/IntuneRoleAssignment/' ],
    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/MgBetaDeviceManagementRoleAssignment/MgBetaDeviceManagementRoleAssignment/',     '/DSC/IntuneRoleAssignment/IntuneRoleAssignment/' ],

    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/MgBetaDeviceManagementRoleDefinition/',                                          '/DSC/IntuneRoleDefinition/' ],
    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/MgBetaDeviceManagementRoleDefinition/MgBetaDeviceManagementRoleDefinition/',     '/DSC/IntuneRoleDefinition/IntuneRoleDefinition/' ],

    [ WsDeliverConfigSchemaMappingStatus.Mapped, '/PowerShell/MgBetaDeviceManagementWindowsAutopilotDeploymentProfile/', '/DSC/IntuneWindowsAutopilotDeploymentProfileAzureADHybridJoined/IntuneWindowsAutopilotDeploymentProfileAzureADHybridJoined/' ],

    [ WsDeliverConfigSchemaMappingStatus.Mapped, '/PowerShell/MgDeviceManagementDeviceEnrollmentConfiguration/',                                                 '/DSC/IntuneDeviceEnrollmentStatusPageWindows10/' ],
    [ WsDeliverConfigSchemaMappingStatus.Mapped, '/PowerShell/MgDeviceManagementDeviceEnrollmentConfiguration/MgDeviceManagementDeviceEnrollmentConfiguration/', '/DSC/IntuneDeviceEnrollmentStatusPageWindows10/IntuneDeviceEnrollmentStatusPageWindows10/' ],

    [ WsDeliverConfigSchemaMappingStatus.Missing, '/PowerShell/MgSubscribedSku/' ],





    // onedrive

    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/PnPTenant/',                      '/DSC/ODSettings/' ],

    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/PnPTenantSyncClientRestriction/', '/DSC/ODSettings/' ],


    // planner

    [ WsDeliverConfigSchemaMappingStatus.Ignore , '/PowerShell/MgPlanner/' ],


















    // sharepoint

    [ WsDeliverConfigSchemaMappingStatus.Ignore, '/PowerShell/PnPAppErrors/' ],

    [ WsDeliverConfigSchemaMappingStatus.ReadOnly, '/PowerShell/PnPAvailableLanguage/' ],

    [ WsDeliverConfigSchemaMappingStatus.Missing, '/PowerShell/PnPBrowserIdleSignout/' ],

    [ WsDeliverConfigSchemaMappingStatus.Missing, '/PowerShell/PnPBuiltInDesignPackageVisibility/' ],

    [ WsDeliverConfigSchemaMappingStatus.ReadOnly, '/PowerShell/PnPDiagnostics/' ],
    
    [ WsDeliverConfigSchemaMappingStatus.ReadOnly, '/PowerShell/PnPEventReceiver/' ],
    
    [ WsDeliverConfigSchemaMappingStatus.ReadOnly, '/PowerShell/PnPFeature/' ],

    [ WsDeliverConfigSchemaMappingStatus.Missing, '/PowerShell/PnPField/' ],
    
    [ WsDeliverConfigSchemaMappingStatus.ReadOnly, '/PowerShell/PnPIndexedPropertyKeys/' ],
    
    [ WsDeliverConfigSchemaMappingStatus.Missing, '/PowerShell/PnPListInformationRightsManagement/' ],
    
    [ WsDeliverConfigSchemaMappingStatus.Missing, '/PowerShell/PnPMasterPage/' ],
    
    [ WsDeliverConfigSchemaMappingStatus.Missing, '/PowerShell/PnPRoleDefinition/' ],
    
    [ WsDeliverConfigSchemaMappingStatus.Missing, '/PowerShell/PnPSearchSettings/' ],
    
    [ WsDeliverConfigSchemaMappingStatus.ReadOnly, '/PowerShell/PnPSiteCollectionAdmin/' ],
    
    [ WsDeliverConfigSchemaMappingStatus.Missing, '/PowerShell/PnPSiteGroup/' ],

    [ WsDeliverConfigSchemaMappingStatus.ReadOnly, '/PowerShell/PnPSiteSearchQueryResults/' ],


    [ WsDeliverConfigSchemaMappingStatus.Missing, '/PowerShell/PnPTenantCdnEnabled/' ],

    [ WsDeliverConfigSchemaMappingStatus.Missing, '/PowerShell/PnPTenantSite/' ],

    [ WsDeliverConfigSchemaMappingStatus.Missing, '/PowerShell/PnPTheme/' ],

    [ WsDeliverConfigSchemaMappingStatus.ReadOnly, '/PowerShell/PnPTimeZoneId/' ],

    [ WsDeliverConfigSchemaMappingStatus.ReadOnly, '/PowerShell/PnPUPABulkImportStatus/' ],

    [ WsDeliverConfigSchemaMappingStatus.ReadOnly, '/PowerShell/PnPUser/' ],

    [ WsDeliverConfigSchemaMappingStatus.Missing, '/PowerShell/PnPUserOneDriveQuota/' ],

    [ WsDeliverConfigSchemaMappingStatus.Missing, '/PowerShell/PnPUserProfileProperty/' ],

    [ WsDeliverConfigSchemaMappingStatus.Missing, '/PowerShell/PnPView/' ],

    [ WsDeliverConfigSchemaMappingStatus.ReadOnly, '/PowerShell/PnPWebTemplates/' ],

    [ WsDeliverConfigSchemaMappingStatus.ReadOnly, '/PowerShell/SPOSiteCollectionAppCatalogs/' ],

    [ WsDeliverConfigSchemaMappingStatus.Ignore, '/PowerShell/SPOUserProfilePropertyInstance/' ],

    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/MgAdminSharepointSetting/',           '/DSC/SPOSharingSettings/' ],

    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/MgBetaAdminSharepointSetting/',       '/DSC/SPOSharingSettings/' ],

    [ WsDeliverConfigSchemaMappingStatus.Ignore,  '/PowerShell/SPOCrossGeoMovedUsers/',           '' ],

    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/PnPPropertyBag/',       '/DSC/SPOPropertyBag/' ],
    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/PnPPropertyBag/PnPPropertyBag/',       '/DSC/SPOPropertyBag/SPOPropertyBag/' ],
    
    [ WsDeliverConfigSchemaMappingStatus.Missing,  '/PowerShell/SPOBuiltInDesignPackageVisibility/',           '' ],

    [ WsDeliverConfigSchemaMappingStatus.Ignore,  '/PowerShell/SPOCrossGeoMovedUsers/',           '' ],

    [ WsDeliverConfigSchemaMappingStatus.Ignore,  '/PowerShell/SPOCrossGeoMoveReport/',           '' ],    

    [ WsDeliverConfigSchemaMappingStatus.Ignore,  '/PowerShell/SPOCrossTenantCompatibilityStatus/',           '' ],

    [ WsDeliverConfigSchemaMappingStatus.Ignore,  '/PowerShell/SPOGeoMoveCrossCompatibilityStatus/',           '' ],

    [ WsDeliverConfigSchemaMappingStatus.ReadOnly,  '/PowerShell/SPOGeoStorageQuota/',           '' ],

    [ WsDeliverConfigSchemaMappingStatus.ReadOnly,  '/PowerShell/SPOIsCommSite/',           '' ],

    [ WsDeliverConfigSchemaMappingStatus.ReadOnly,  '/PowerShell/SPOKnowledgeHubSite/',           '' ],

    [ WsDeliverConfigSchemaMappingStatus.ReadOnly,  '/PowerShell/SPOOrgNewsSite/',           '' ],

    [ WsDeliverConfigSchemaMappingStatus.Ignore,  '/PowerShell/SPOPortalLaunchWaves/',           '' ],

    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/SPOSite/',           '/DSC/SPOSite/' ],

    [ WsDeliverConfigSchemaMappingStatus.Ignore,  '/PowerShell/SPOSiteContentMoveState/',           '' ],

    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/SPOSiteGroup/',           '/DSC/SPOSiteGroup/' ],

    [ WsDeliverConfigSchemaMappingStatus.Ignore,  '/PowerShell/SPOSiteRenameState/',           '' ],
    
    [ WsDeliverConfigSchemaMappingStatus.Ignore,  '/PowerShell/SPOStructuralNavigationCacheSiteState/',           '' ],
    
    [ WsDeliverConfigSchemaMappingStatus.Ignore,  '/PowerShell/SPOStructuralNavigationCacheWebState/',           '' ],
    
    [ WsDeliverConfigSchemaMappingStatus.Ignore,  '/PowerShell/SPOStructuralNavigationCacheWebState/',           '' ],

    [ WsDeliverConfigSchemaMappingStatus.ReadOnly,  '/PowerShell/SPOTenantLogLastAvailableTimeInUtc/',           '' ],
    
    [ WsDeliverConfigSchemaMappingStatus.Ignore,  '/PowerShell/SPOTenantRenameSitePrioritization/',           '' ],
    
    [ WsDeliverConfigSchemaMappingStatus.Ignore,  '/PowerShell/SPOTenantRenameStatus/',           '' ],
    
    [ WsDeliverConfigSchemaMappingStatus.Missing,  '/PowerShell/SPOTenantSyncClientRestriction/',           '' ],
    
    [ WsDeliverConfigSchemaMappingStatus.Ignore,  '/PowerShell/SPOUnifiedGroupMoveState/',           '' ],
    
    [ WsDeliverConfigSchemaMappingStatus.Missing,  '/PowerShell/SPOUser/',           '' ],
    
    [ WsDeliverConfigSchemaMappingStatus.Ignore,  '/PowerShell/SPOUserAndContentMoveState/',           '' ],
    
    [ WsDeliverConfigSchemaMappingStatus.Ignore,  '/PowerShell/SPOUserOneDriveLocation/',           '' ],
    
    [ WsDeliverConfigSchemaMappingStatus.Missing,  '/PowerShell/SPOWebTemplate/',           '' ],





    // teams

    
    [ WsDeliverConfigSchemaMappingStatus.Missing,  '/PowerShell/CsApplicationAccessPolicy/' ],

    
    [ WsDeliverConfigSchemaMappingStatus.Missing,  '/PowerShell/CsApplicationMeetingConfiguration/' ],

    
    [ WsDeliverConfigSchemaMappingStatus.Missing,  '/PowerShell/CsAutoAttendantSupportedLanguage/' ],

    
    [ WsDeliverConfigSchemaMappingStatus.Missing,  '/PowerShell/CsAutoAttendantSupportedTimeZone/' ],

    
    [ WsDeliverConfigSchemaMappingStatus.Missing,  '/PowerShell/CsAutoAttendantTenantInformation/' ],

    
    [ WsDeliverConfigSchemaMappingStatus.Missing,  '/PowerShell/CsCallingLineIdentity/' ],




    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/CsDialPlan/',                                         '/DSC/TeamsTenantDialPlan/' ],
    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/CsDialPlan/CsDialPlan/',                              '/DSC/TeamsTenantDialPlan/TeamsTenantDialPlan/' ],

    [ WsDeliverConfigSchemaMappingStatus.Missing,  '/PowerShell/CsEffectiveTenantDialPlan/' ],    

    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/CsExternalAccessPolicy/',                                                                          '/DSC/TeamsFederationConfiguration/' ],
    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/CsExternalAccessPolicy/CsExternalAccessPolicy/',                                                   '/DSC/TeamsFederationConfiguration/TeamsFederationConfiguration/' ],
    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/CsExternalAccessPolicy/CsExternalAccessPolicy/EnableTeamsConsumerAccess/',                         '/DSC/TeamsFederationConfiguration/TeamsFederationConfiguration/AllowTeamsConsumer/' ],
    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/CsExternalAccessPolicy/CsExternalAccessPolicy/EnableTeamsConsumerInbound/',                        '/DSC/TeamsFederationConfiguration/TeamsFederationConfiguration/AllowTeamsConsumerInbound/' ],
    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/CsExternalAccessPolicy/CsExternalAccessPolicy/RestrictTeamsConsumerAccessToExternalUserProfiles/', '/DSC/TeamsFederationConfiguration/TeamsFederationConfiguration/RestrictTeamsConsumerToExternalUserProfiles/' ],
    
    [ WsDeliverConfigSchemaMappingStatus.Missing,  '/PowerShell/CsOnlineAudioConferencingRoutingPolicy/' ],

    [ WsDeliverConfigSchemaMappingStatus.Missing,  '/PowerShell/CsOnlineDialInConferencingBridge/' ],

    [ WsDeliverConfigSchemaMappingStatus.Ignore,  '/PowerShell/CsOnlineDialInConferencingLanguagesSupported/' ],

    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/CsOnlineDialInConferencingTenantSettings/',           '/DSC/TeamsDialInConferencingTenantSettings/' ],

    [ WsDeliverConfigSchemaMappingStatus.Missing,  '/PowerShell/CsOnlineDialinConferencingPolicy/' ],

    [ WsDeliverConfigSchemaMappingStatus.Ignore,  '/PowerShell/CsOnlineDialInConferencingServiceNumber/' ],

    [ WsDeliverConfigSchemaMappingStatus.Missing,  '/PowerShell/CsOnlineDialinConferencingTenantConfiguration/' ],

    [ WsDeliverConfigSchemaMappingStatus.Ignore,  '/PowerShell/CsOnlineDialInConferencingUser/' ],

    [ WsDeliverConfigSchemaMappingStatus.Ignore,  '/PowerShell/CsOnlineEnhancedEmergencyServiceDisclaimer/' ],

    [ WsDeliverConfigSchemaMappingStatus.Ignore,  '/PowerShell/CsOnlinePstnUsage/' ],

    [ WsDeliverConfigSchemaMappingStatus.Missing,  '/PowerShell/CsOnlineSipDomain/' ],


    
    [ WsDeliverConfigSchemaMappingStatus.Ignore,  '/PowerShell/CsOnlineTelephoneNumberCountry/' ],

    
    [ WsDeliverConfigSchemaMappingStatus.Ignore,  '/PowerShell/CsOnlineTelephoneNumberType/' ],

    
    [ WsDeliverConfigSchemaMappingStatus.ReadOnly, '/PowerShell/CsOnlineUser/' ],



    

    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/CsOnlineVoicemailPolicy/',                              '/DSC/TeamsOnlineVoicemailPolicy/' ],
    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/CsOnlineVoicemailPolicy/CsOnlineVoicemailPolicy/',      '/DSC/TeamsOnlineVoicemailPolicy/TeamsOnlineVoicemailPolicy/' ],

    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/CsOnlineVoicemailUserSettings/',                        '/DSC/TeamsOnlineVoicemailUserSettings/TeamsOnlineVoicemailUserSettings/' ],


    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/CsOnlineVoiceRoute/',                        '/DSC/TeamsVoiceRoute/TeamsVoiceRoute/' ],

    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/CsOnlineVoiceRoutingPolicy/',                        '/DSC/TeamsVoiceRoutingPolicy/TeamsVoiceRoutingPolicy/' ],


    
    [ WsDeliverConfigSchemaMappingStatus.Missing,  '/PowerShell/CsPrivacyConfiguration/' ],


    
    [ WsDeliverConfigSchemaMappingStatus.Missing,  '/PowerShell/CsTeamsAcsFederationConfiguration/' ],

    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/CsTeamsAppPermissionPolicy/',                                '/DSC/TeamsAppPermissionPolicy/TeamsAppPermissionPolicy/' ],




    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/CsTeamsEventsPolicy/',                                '/DSC/TeamsEventsPolicy/TeamsEventsPolicy/' ],

    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/CsTeamsFeedbackPolicy/',                              '/DSC/TeamsFeedbackPolicy/' ],
    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/CsTeamsFeedbackPolicy/TeamsFeedbackPolicy/',          '/DSC/TeamsFeedbackPolicy/TeamsFeedbackPolicy/' ],

    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/CsTeamsGuestMessagingConfiguration/',                 '/DSC/TeamsGuestMessagingConfiguration/TeamsGuestMessagingConfiguration/' ],

    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/CsTeamsIPPhonePolicy/',                 '/DSC/TeamsIPPhonePolicy/TeamsIPPhonePolicy/' ],


    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/CsTeamsMeetingPolicy/',                       '/DSC/TeamsMeetingPolicy/' ],
    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/CsTeamsMeetingPolicy/CsTeamsMeetingPolicy/',  '/DSC/TeamsMeetingPolicy/TeamsMeetingPolicy/' ],


    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/CsTeamsMessagingPolicy/',                        '/DSC/TeamsMessagingPolicy/' ],
    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/CsTeamsMessagingPolicy/CsTeamsMessagingPolicy/', '/DSC/TeamsMessagingPolicy/TeamsMessagingPolicy/' ],



    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/CsTeamsShiftsPolicy/',                     '/DSC/TeamsShiftsPolicy/' ],
    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/CsTeamsShiftsPolicy/CsTeamsShiftsPolicy/', '/DSC/TeamsShiftsPolicy/TeamsShiftsPolicy/' ],

    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/CsTeamsUpdateManagementPolicy/',                               '/DSC/TeamsUpdateManagementPolicy/' ],
    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/CsTeamsUpdateManagementPolicy/CsTeamsUpdateManagementPolicy/', '/DSC/TeamsUpdateManagementPolicy/TeamsUpdateManagementPolicy/' ],



    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/CsTeamsUpgradePolicy/',                               '/DSC/TeamsUpgradePolicy/' ],
    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/CsTeamsUpgradePolicy/CsTeamsUpgradePolicy/', '/DSC/TeamsUpgradePolicy/TeamsUpgradePolicy/' ],

    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/CsTeamsVdiPolicy/',                               '/DSC/TeamsVdiPolicy/' ],



    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/CsTenantFederationConfiguration/',                               '/DSC/TeamsFederationConfiguration/TeamsFederationConfiguration/' ],



    

    
    
    [ WsDeliverConfigSchemaMappingStatus.Missing,  '/PowerShell/CsTeamsSipDevicesConfiguration/',                                '' ],

    [ WsDeliverConfigSchemaMappingStatus.Missing,  '/PowerShell/CsTeamsSurvivableBranchAppliance/',                                '' ],
    
    [ WsDeliverConfigSchemaMappingStatus.Missing,  '/PowerShell/CsTeamsTargetingPolicy/',                                '' ],

    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/CsTeamsUpgradeConfiguration/',                               '/DSC/TeamsUpgradeConfiguration/' ],
    


    [ WsDeliverConfigSchemaMappingStatus.Missing,  '/PowerShell/CsTeamsVideoInteropServicePolicy/',                                '' ],

    [ WsDeliverConfigSchemaMappingStatus.Missing,  '/PowerShell/CsTeamsVirtualAppointmentsPolicy/',                                '' ],




    [ WsDeliverConfigSchemaMappingStatus.Missing,  '/PowerShell/CsTenantLicensingConfiguration/',                                '' ],

    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/CsUserPolicyAssignment/',                                '/DSC/TeamsUserPolicyAssignment/' ],
    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/CsUserPolicyAssignment/CsUserPolicyAssignment/',         '/DSC/TeamsUserPolicyAssignment/TeamsUserPolicyAssignment/' ],


    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/MgBetaTeamChannel/',                                '/DSC/TeamsChannel/TeamsChannel/' ],


    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/MgBetaTeamChannelTab/',                                '/DSC/TeamsChannelTab/' ],
    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/MgBetaTeamChannelTab/MgBetaTeamChannelTab/',         '/DSC/TeamsChannelTab/TeamsChannelTab/' ],


    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/Team/',              '/DSC/TeamsTeam/' ],
    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/Team/Team/',         '/DSC/TeamsTeam/TeamsTeam/' ],


    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/CsTeamsWorkLoadPolicy/',              '/DSC/TeamsWorkloadPolicy/TeamsWorkloadPolicy/' ],

    
    [ WsDeliverConfigSchemaMappingStatus.Missing,  '/PowerShell/CsTeamsWorkLocationDetectionPolicy/',                                '' ],
    [ WsDeliverConfigSchemaMappingStatus.Missing,  '/PowerShell/CsTeamTemplate/',                                '' ],
    [ WsDeliverConfigSchemaMappingStatus.Missing,  '/PowerShell/CsTeamTemplateList/',                                '' ],

    [ WsDeliverConfigSchemaMappingStatus.Missing,  '/PowerShell/CsTenant/',                                '' ],
    [ WsDeliverConfigSchemaMappingStatus.Missing,  '/PowerShell/CsTenantBlockedCallingNumbers/',                                '' ],

    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/CsTenantDialPlan/',              '/DSC/TeamsTenantDialPlan/TeamsTenantDialPlan/' ],


    [ WsDeliverConfigSchemaMappingStatus.Missing,  '/PowerShell/CsTenantMigrationConfiguration/',                                '' ],
    [ WsDeliverConfigSchemaMappingStatus.Missing,  '/PowerShell/CsTenantNetworkConfiguration/',                                '' ],

    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/CsUserCallingSettings/',              '/DSC/TeamsUserCallingSettings/TeamsUserCallingSettings/' ],






    [ WsDeliverConfigSchemaMappingStatus.ReadOnly, '/PowerShell/TeamAllChannel/',                                '' ],
    [ WsDeliverConfigSchemaMappingStatus.Missing,  '/PowerShell/TeamChannelUser/',                                '' ],
    [ WsDeliverConfigSchemaMappingStatus.Missing,  '/PowerShell/TeamsApp/',                                '' ],


    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/TeamUser/',          '/DSC/TeamsUser/' ],
    [ WsDeliverConfigSchemaMappingStatus.Mapped,  '/PowerShell/TeamUser/TeamUser/', '/DSC/TeamsUser/TeamsUser/' ],


    [ WsDeliverConfigSchemaMappingStatus.Missing,  '/PowerShell/CsOnlineDialOutPolicy/',                                '' ],

    [ WsDeliverConfigSchemaMappingStatus.Missing,  '/PowerShell/CsTeamsVoiceApplicationsPolicy/', '' ],

  ];



  const mappedResourceList: WsDeliverConfigSchemaMapping[] = list.map((item): WsDeliverConfigSchemaMapping => {

    if (item[1] && !item[1].endsWith('/')) {
      console.error('missing "/"');
    }
    
    if (item[2] && !item[2].endsWith('/')) {
      console.error('missing "/"');
    }

    return {
      workload:   WsDeliverConfigWorkload.NotSet,
      type:       WsDeliverConfigItemType.NotSet,
      status:     item[0],
      sourcePath: item[1],
      targetPath: item[2] || '',
      comments:    '',
      description: '',
      auto: false
    }
  });



  if (sorted) {
    return sortMappingList(mappedResourceList);
  } else {
    return mappedResourceList;
  }
};




export const sortMappingList = (mappingList: WsDeliverConfigSchemaMapping[]) => {

  return mappingList.sort((a, b) => {

    return naturalCompare(b.sourcePath.toLowerCase(), a.sourcePath.toLowerCase());

    // if (a.sourcePath.toLowerCase() > b.sourcePath.toLowerCase()) return -1;
    // if (a.sourcePath.toLowerCase() < b.sourcePath.toLowerCase()) return  1;
    // return 0;
  });
};




export const getSchemaMappingStatus = (value: string): WsDeliverConfigSchemaMappingStatus => {

  if (value === 'REVIEW') {
    return WsDeliverConfigSchemaMappingStatus.Review;

  } else if (value === 'MAPPED') {
    return WsDeliverConfigSchemaMappingStatus.Mapped;

  } else if (value === 'READ_ONLY') {
    return WsDeliverConfigSchemaMappingStatus.ReadOnly;

  } else if (value === 'IGNORE') {
    return WsDeliverConfigSchemaMappingStatus.Ignore;

  } else if (value === 'MISSING') {
    return WsDeliverConfigSchemaMappingStatus.Missing;

  } else {
    return WsDeliverConfigSchemaMappingStatus.Review;
  }
};




export const getSchemaMappingStatusName = (status: WsDeliverConfigSchemaMappingStatus) => {

  if (status === WsDeliverConfigSchemaMappingStatus.Review) {
    return 'In Review';

  } else if (status === WsDeliverConfigSchemaMappingStatus.Mapped) {
    return 'Mapped';

  } else if (status === WsDeliverConfigSchemaMappingStatus.ReadOnly) {
    return 'Read-Only';

  } else if (status === WsDeliverConfigSchemaMappingStatus.Ignore) {
    return 'Ignore';  

  } else if (status === WsDeliverConfigSchemaMappingStatus.Missing) {
    return 'Missing';

  } else {
    return ''
  }
};




export const resourceTypeIsResource = (type: WsDeliverConfigItemType, includeResourceArray?: boolean) => {

  if (includeResourceArray) {

    return [
      WsDeliverConfigItemType.Resources, // this is top level resource[] not field level
      WsDeliverConfigItemType.Resource,
      WsDeliverConfigItemType.Instance
    ].includes(type);

  } else {

    return [
      WsDeliverConfigItemType.Resource,
      WsDeliverConfigItemType.Instance
    ].includes(type);
  }
};




export const resourceTypeIsValue = (type: WsDeliverConfigItemType) => {

  return [

    WsDeliverConfigItemType.String,
    WsDeliverConfigItemType.Number,
    WsDeliverConfigItemType.Boolean,
    WsDeliverConfigItemType.ListOfResources,
    WsDeliverConfigItemType.ListOfStrings,
    WsDeliverConfigItemType.ListOfNumbers,
    WsDeliverConfigItemType.ListOfBooleans,

  ].includes(type);

};




const getSchemaMappingList = (sourceSchemaList: WsDeliverConfigSchemaItem[], dscSchemaList: WsDeliverConfigSchemaItem[], staticMappingList: WsDeliverConfigSchemaMapping[]) => {
  // console.clear();
  // console.log('getSchemaMappingList');

  const mappingList: WsDeliverConfigSchemaMapping[] = [];

  sourceSchemaList.forEach((sourceSchemaItem) => {

    const mappedResourceItem = staticMappingList.find((item) => {
      return startsWith(sourceSchemaItem.schemaPath, item.sourcePath); // && sourceSchemaItem.schemaPath !== item.sourcePath;
    });

    if (mappedResourceItem) {
      // console.log('================================================================================');
      // console.log(`map : ${sourceSchemaItem.schemaPath}`);

      // if (mappedResourceItem.sourcePath === sourceSchemaItem.schemaPath) {
      //   mappedResourceItem.workload = sourceSchemaItem.workload;
      //   mappedResourceItem.type     = sourceSchemaItem.type;
      // }

      const direct = mappedResourceItem.sourcePath === sourceSchemaItem.schemaPath ? true : false;

      if (
        mappedResourceItem.status === WsDeliverConfigSchemaMappingStatus.Review
        ||
        mappedResourceItem.status === WsDeliverConfigSchemaMappingStatus.ReadOnly
        ||
        mappedResourceItem.status === WsDeliverConfigSchemaMappingStatus.Ignore
        ||
        mappedResourceItem.status === WsDeliverConfigSchemaMappingStatus.Missing
      ) {

        mappingList.push({
          workload:    sourceSchemaItem.workload,
          type:        sourceSchemaItem.type,
          sourcePath:  sourceSchemaItem.schemaPath,
          targetPath:  mappedResourceItem.targetPath,
          status:      mappedResourceItem.status,
          comments:    direct ? mappedResourceItem.comments    : '',
          description: direct ? mappedResourceItem.description : '',
          auto: (mappedResourceItem.sourcePath !== sourceSchemaItem.schemaPath)
        });

      } else {

        const sourceBasePath = mappedResourceItem.sourcePath;
        const dscBasePath    = mappedResourceItem.targetPath;

        const findSchemaPath = sourceSchemaItem.schemaPath.replace(sourceBasePath, dscBasePath);

        const findDscSchemaItem = dscSchemaList.find((item) => item.schemaPath.toLowerCase() === findSchemaPath.toLowerCase());

        if (findDscSchemaItem) {

          mappingList.push({
            workload:   sourceSchemaItem.workload,
            type:       sourceSchemaItem.type,
            sourcePath: sourceSchemaItem.schemaPath,
            targetPath: findDscSchemaItem.schemaPath,
            status:     WsDeliverConfigSchemaMappingStatus.Mapped,
            comments:    direct ? mappedResourceItem.comments    : '',
            description: direct ? mappedResourceItem.description : '',
            auto: (mappedResourceItem.sourcePath !== sourceSchemaItem.schemaPath)
          });

        } else {

          if (direct && mappedResourceItem.status === WsDeliverConfigSchemaMappingStatus.Mapped) {

            mappingList.push({
              workload:    sourceSchemaItem.workload,
              type:        sourceSchemaItem.type,
              sourcePath:  sourceSchemaItem.schemaPath,
              targetPath:  mappedResourceItem.targetPath,
              status:      mappedResourceItem.status,
              comments:    direct ? mappedResourceItem.comments    : '',
              description: direct ? mappedResourceItem.description : '',
              auto: (mappedResourceItem.sourcePath !== sourceSchemaItem.schemaPath)
            });

          } else {

            mappingList.push({
              workload:   sourceSchemaItem.workload,
              type:       sourceSchemaItem.type,
              sourcePath: sourceSchemaItem.schemaPath,
              targetPath: '',
              status:     WsDeliverConfigSchemaMappingStatus.Missing,
              comments:    direct ? mappedResourceItem.comments    : '',
              description: direct ? mappedResourceItem.description : '',
              auto: (mappedResourceItem.sourcePath !== sourceSchemaItem.schemaPath)
            });
          }
        }
      }

      // console.log('================================================================================');

    } else {

      mappingList.push({
        workload:   sourceSchemaItem.workload,
        type:       sourceSchemaItem.type,
        sourcePath: sourceSchemaItem.schemaPath,
        targetPath: '',
        status:     WsDeliverConfigSchemaMappingStatus.Review,
        comments:    '',
        description: '',
        auto: false
      });

    }

  });

  // return

  return mappingList;
};




export const startsWith = (a: string, b: string) => {
  if (a && b) {
    return a.toLowerCase().startsWith(b.toLowerCase());
  } else {
    return false;
  }
};




const equals = (a: string, b: string) => {
};




export {
  getStaticResourceMappingList,
  getSchemaMappingList
};
